"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
0 && __export(require("./exports")) && __export(require("./stack")) && __export(require("./link")) && __export(require("./color"));
require("./global");
_export_star(require("./exports"), exports);
_export_star(require("./stack"), exports);
_export_star(require("./link"), exports);
_export_star(require("./color"), exports);
function _export_star(from, to) {
    Object.keys(from).forEach(function(k) {
        if (k !== "default" && !Object.prototype.hasOwnProperty.call(to, k)) {
            Object.defineProperty(to, k, {
                enumerable: true,
                get: function() {
                    return from[k];
                }
            });
        }
    });
    return from;
}

//# sourceMappingURL=index.js.map
